import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AddEditForm from "pages/EmployeeWorkspace/components/Tabs/components/CivilServiceTab/components/AddEditForm";
import { formatDateForInput } from "utils/helpers/dateHelper";
import resource from "pages/EmployeeWorkspace/Resources/civilServiceResource";

import schema from "pages/EmployeeWorkspace/validation/civilServiceSchema";

const defaultValues = {
    accreditation: "",
    dateTaken: null,
    placeTaken: null,
    licenseNumber: null,
    validityDate: null
};

export default function FormDialog({ open, item, onSave, onCancel }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(schema)
    });

    const onError = (errors) => {
        console.log({ errors });
    };

    useEffect(() => {
        if (open) {
            reset({
                ...defaultValues,
                ...item,
                dateTaken: formatDateForInput(item?.dateTaken),
                validityDate: formatDateForInput(item?.validityDate)
            });
        }
    }, [open, item, reset]);

    const onSubmit = (data) => {
        onSave({
            ...data,
            dateTaken: data?.dateTaken || null,
            validityDate: data?.validityDate || null
        });
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {item ? `Edit ${resource.title}` : `Add ${resource.title}`}
            </DialogTitle>

            <DialogContent dividers>
                <AddEditForm
                    register={register}
                    errors={errors}
                    control={control}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
}
